import { UserResponse, UserUpdate } from '@/schema/user';
import Api from './api';

const ProfileApi = {
  getProfile() {
    return Api.get<UserResponse>('/me');
  },

  updateProfile(data: UserUpdate) {
    return Api.put<UserResponse>('/me', data);
  },
};

export default ProfileApi;
